import React from 'react';
import { useSelector } from 'react-redux';
import TRANSLATIONS from '../../translations/translations@default.json';

export const SortByDiscount = () => {
    const { sorting } = useSelector((state: any) => state);

    const currentOption = sorting?.AvailableSortOptions?.find(
        (opt: any) => opt.SortKey === sorting?.CurrentSortBy
    );

    const isDiscountSelected = currentOption?.SortPhrase?.toLowerCase().includes('discount');
    if (!isDiscountSelected) return null;

    return (
        <div className="text-sm text-primary px-2 whitespace-no-wrap">
            {TRANSLATIONS.controls.sortBy.sortByDiscountText}
        </div>
    );
};

export default SortByDiscount;
